import FixtureTeamManagementModule from '@/modules/fixture-team-management';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/fantasy/fixture/fixture-team-management'
)({
  validateSearch: searchSchema,
  component: FixtureTeamManagementPage,
});

function FixtureTeamManagementPage() {
  return <FixtureTeamManagementModule />;
}
